import React from "react";
import Preguntas from "./Preguntas";
import { Link } from "react-router-dom";
import { auth, db } from "../firebase";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap";

const CheckIcon = () => (
  <span className="sb-feature-check">✓</span>
);

class Precios extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      selectedView: "Monthly",
      name: '',
      lastName: '',
      phoneNumber: '',
      address: '',
      postalCode: '',
      city: '',
    };
  }

  toggleModal = () => {
    this.setState(prevState => ({ showModal: !prevState.showModal }));
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.toggleModal();
  };

  openPrice(url) {
    if (auth.currentUser) {
      this.setState({ showModal: true, url });
    } else {
      toast.error("Log in first");
      window.location.href = "/login";
    }
  }

  gotoLink() {
    db.collection("users").doc(auth.currentUser?.email).set(this.state, { merge: true }).then(() => {
      window.location.href = this.state.url;
    });
  }

  renderPrices() {
    const isDaily = this.state.selectedView === "Daily";

    const plans = [
      {
        name: "Simple",
        price: isDaily ? "10" : "434",
        period: isDaily ? "/ day" : "/ month",
        billing: isDaily ? "Billed daily" : "Billed monthly",
        features: [
          "Access to 2 roulette tables",
          "Limited lifetime analysis",
        ],
        cta: "Get started",
        featured: false,
        url: "https://buy.stripe.com/14k17QdNd8ASfoA5kk",
      },
      {
        name: "Advanced",
        price: isDaily ? "30" : "651",
        period: isDaily ? "/ day" : "/ month",
        billing: isDaily ? "Billed daily" : "Billed monthly",
        features: [
          "Access to all roulette tables",
          "Full lifetime statistics",
          "Unlimited lifetime analysis",
          "Deep-analytics insights",
          "API access to database",
          "24/7 Support",
        ],
        cta: "Get started",
        featured: true,
        url: "https://buy.stripe.com/14k17QdNd8ASfoA5kk",
      },
    ];

    return (
      <div className="row g-4 justify-content-center">
        {plans.map((plan) => (
          <div key={plan.name} className="col-12 col-md-5">
            <div className={`sb-pricing-card${plan.featured ? ' featured' : ''}`}>
              {plan.featured && <div className="sb-pricing-badge">Best value</div>}

              <p className="sb-pricing-name">{plan.name} plan</p>

              <div className="d-flex align-items-baseline gap-1 mb-1">
                <span className="sb-pricing-currency">€</span>
                <span className="sb-pricing-price">{plan.price}</span>
              </div>
              <p className="sb-pricing-period">{plan.period} · {plan.billing}</p>

              <hr className="sb-pricing-divider" />

              <ul className="sb-feature-list">
                {plan.features.map((f) => (
                  <li key={f}><CheckIcon />{f}</li>
                ))}
              </ul>

              <button
                onClick={() => this.openPrice(plan.url)}
                className={`btn w-100 ${plan.featured ? 'btn-primary' : 'btn-dark'}`}
              >
                {plan.cta}
              </button>
            </div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    return (
      <>
        {/* ── Info modal ────────────────────────────────────── */}
        <Modal show={this.state.showModal} onHide={this.toggleModal} centered>
          <Modal.Header
            closeButton
            style={{
              background: 'var(--sb-bg-elevated)',
              border: '1px solid var(--sb-border)',
              borderBottom: '1px solid var(--sb-border)',
            }}
          >
            <Modal.Title style={{ color: 'var(--sb-text-primary)', fontSize: '1rem', fontWeight: 600 }}>
              Your information
            </Modal.Title>
          </Modal.Header>
          <form onSubmit={this.handleSubmit}>
            <div
              className="modal-body"
              style={{ background: 'var(--sb-bg-elevated)', padding: '1.5rem' }}
            >
              <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.85rem', marginBottom: '1.25rem' }}>
                We need a few details before redirecting you to payment.
              </p>
              <div className="row g-3">
                {[
                  { label: 'First name',    name: 'name',        type: 'text' },
                  { label: 'Last name',     name: 'lastName',    type: 'text' },
                  { label: 'Phone number',  name: 'phoneNumber', type: 'tel' },
                  { label: 'Address',       name: 'address',     type: 'text' },
                  { label: 'Postal code',   name: 'postalCode',  type: 'text' },
                  { label: 'City',          name: 'city',        type: 'text' },
                ].map(({ label, name, type }) => (
                  <div key={name} className="col-12 col-sm-6">
                    <label style={{ color: 'var(--sb-text-muted)', fontSize: '0.75rem', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '0.4rem', display: 'block' }}>
                      {label}
                    </label>
                    <input
                      type={type}
                      className="form-control"
                      name={name}
                      value={this.state[name]}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                ))}
              </div>
            </div>
            <div
              style={{
                background: 'var(--sb-bg-elevated)',
                borderTop: '1px solid var(--sb-border)',
                padding: '1rem 1.5rem',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '0.75rem',
              }}
            >
              <button type="button" className="btn btn-dark" onClick={this.toggleModal}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" onClick={() => this.gotoLink()}>
                Continue to payment →
              </button>
            </div>
          </form>
        </Modal>

        <main>
          {/* ── Page header ───────────────────────────────────── */}
          <section
            style={{
              padding: '5rem 0 3.5rem',
              background: 'radial-gradient(ellipse 80% 50% at 50% -10%, rgba(59,130,246,0.12) 0%, transparent 60%), var(--sb-bg-base)',
              textAlign: 'center',
            }}
          >
            <div className="container">
              <div className="sb-section-label" style={{ marginBottom: '0.75rem' }}>Pricing</div>
              <h1
                style={{
                  fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
                  fontWeight: 800,
                  color: 'var(--sb-text-primary)',
                  letterSpacing: '-0.03em',
                  marginBottom: '0.75rem',
                }}
              >
                Simple, transparent pricing
              </h1>
              <p style={{ color: 'var(--sb-text-secondary)', fontSize: '1rem', maxWidth: 420, margin: '0 auto 2.5rem' }}>
                Full access to all Evolution roulette table data — no hidden fees.
              </p>

              {/* Billing toggle */}
              <div
                style={{
                  display: 'inline-flex',
                  background: 'var(--sb-bg-card)',
                  border: '1px solid var(--sb-border)',
                  borderRadius: '999px',
                  padding: '4px',
                  gap: '4px',
                }}
              >
                {['Monthly', 'Daily'].map((view) => (
                  <button
                    key={view}
                    onClick={() => this.setState({ selectedView: view })}
                    style={{
                      padding: '0.4rem 1.25rem',
                      borderRadius: '999px',
                      border: 'none',
                      fontSize: '0.85rem',
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      background: this.state.selectedView === view ? 'var(--sb-accent)' : 'transparent',
                      color: this.state.selectedView === view ? '#fff' : 'var(--sb-text-secondary)',
                    }}
                  >
                    {view}
                  </button>
                ))}
              </div>
            </div>
          </section>

          {/* ── Cards ─────────────────────────────────────────── */}
          <section style={{ padding: '0 0 5rem', background: 'var(--sb-bg-base)' }}>
            <div className="container">
              {this.renderPrices()}

              {/* Trust row */}
              <div
                style={{
                  marginTop: '3rem',
                  padding: '1.5rem 2rem',
                  background: 'var(--sb-bg-surface)',
                  border: '1px solid var(--sb-border)',
                  borderRadius: 'var(--sb-radius-lg)',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '1.5rem',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {[
                  { icon: '🔒', text: 'Secure payment via Stripe' },
                  { icon: '↩️', text: 'Refund policy available' },
                  { icon: '📊', text: 'Real-time data, always up to date' },
                  { icon: '✉️', text: 'Support at info@stakebits.co' },
                ].map(({ icon, text }) => (
                  <div
                    key={text}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      color: 'var(--sb-text-secondary)',
                      fontSize: '0.85rem',
                    }}
                  >
                    <span>{icon}</span>
                    <span>{text}</span>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* ── FAQ ───────────────────────────────────────────── */}
          <Preguntas />
        </main>
      </>
    );
  }
}

export default Precios;
